import styled, { css } from 'styled-components';

//helpers
import { screen } from '@/helpers/screen';

//miranda tokens
import { getToken } from '@loadsmart/miranda-tokens';

//theme
import { homeColor } from '@/theme/ai';

//components
import {
  Section,
  SectionTitle,
  SectionLede,
  Kicker,
} from '@/containers-ai/SectionHeading';

export const ProofSection = styled(Section)`
  background: ${homeColor.bg2};
  position: relative;
  text-align: center;

  &::before {
    content: '';
    position: absolute;
    inset: 0;
    background-image: radial-gradient(
      circle,
      rgba(255, 255, 255, 0.045) 1px,
      transparent 1.6px
    );
    background-size: 26px 26px;
    opacity: 0.3;
    pointer-events: none;
  }
`;

export const SectionTitleCustom = styled(SectionTitle)`
  margin: 0 auto 16px;
  max-width: initial;
`;

export const KickerCustom = styled(Kicker)`
  margin: auto;
  width: fit-content;
`;

export const BigNums = styled.div`
  position: relative;
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 26px;
  margin-top: 44px;

  /* Font size of the numeric outcomes. Every value box is as tall as one of
     those numbers, so wordy outcomes (smaller type) still line up with them. */
  --num-size: 40px;

  ${screen.md} {
    --num-size: 48px;
  }

  ${screen.lg} {
    --num-size: 60px;
  }

  ${screen.xxlg} {
    --num-size: 64px;
  }

  /* minmax(0, 1fr): a long outcome ("Centenas de horas") must not widen its
     column, or the three columns stop being equal and centered. */
  ${screen.lg} {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
`;

export const BigNum = styled.div``;

export const BigNumValue = styled.div`
  font-family: ${getToken('font-family-default')};
  font-size: var(--num-size);
  line-height: 1.55;
  min-height: calc(var(--num-size) * 1.55);
  font-weight: 800;
  letter-spacing: -0.03em;
  font-variant-numeric: tabular-nums;
  color: ${homeColor.green};
  display: flex;
  align-items: center;
  justify-content: center;

  /* Wordy outcomes ("Cientos de horas") use smaller type so they fit their
     column; they are centered in the same box height as the numeric ones. */
  ${({ $text }) =>
    $text &&
    css`
      font-size: 36px;
      line-height: 1.15;

      ${screen.lg} {
        font-size: 33px;
        white-space: nowrap;
      }

      ${screen.xxlg} {
        font-size: 44px;
      }
    `}
`;

export const BigNumLabel = styled.div`
  font-family: ${getToken('font-family-default')};
  color: ${homeColor.white};
  font-size: 15px;
  margin: 6px auto 0;
  max-width: 215px;
`;
